import React from "react";
import Collapsible from "react-collapsible";
import Border from "./Border";

import NativeListener from "react-native-listener";

import YouTube from "react-youtube";

import ButtonSettingsModal from "./modal/settings/ButtonSettingsModal";

import PortalModal from "./modal/PortalModal";

import General from "../utils/General";

import Toggle from "./sectioninputs/Toggle";

import { IconAndSVGPicker } from "./IconPickerGrid";

import ImageUploader from "./blocks/editable/ImageUploader";

import $ from "jquery";
import VideoPlayer from "./common/VideoPlayer";
import { getIconType, getStandardIcon, getSVGIcon, updateIconType, updateIconValue } from "./constants/utils";

export default class Play extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: props.overlay,
      icon: props.icon,
      iconImage: props.iconImage,
      videoUrl: props.videoUrl,
      videoSource: props.videoSource,
      pubCode: props.pubCode || "4",
      className: props.className,
      editable: props.editable,
      showEditModal: false,
      showVideoModal: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    this.setState(nextProps);
  }

  _renderVideoModal(videoUrl) {
    let { videoSource, overlay } = this.state;

    let videoId = General.getYoutubeVideoId(videoUrl);

    let videoSize = "yt-video-md";

    if (overlay == 3) {
      videoSize = "yt-video-sm";
    } else if (overlay == 9) {
      videoSize = "yt-video-lg";
    }

    return (
      <PortalModal
        show={this.state.showVideoModal}
        showAsSideMenu="false"
        contentSuperContainerClassName={`bg-dark ${videoSize}`}
        contentContainerClassName=""
        onHide={() => this.setState({ showVideoModal: false })}
      >
        <div className={"yt-video-container"}>
          <VideoPlayer
            videoUrl={videoUrl}
            videoSource={videoSource || "youtube"}
            pubCode={this.state.pubCode}
          />
        </div>
      </PortalModal>
    );
  }

  _renderEditModal(videoUrl) {
    let { overlay, icon, iconImage, videoSource, pubCode} = this.state;

    return (
      <PortalModal
        show={this.state.showEditModal}
        onHide={() => this.setState({ showEditModal: false })}
      >
        <h2>Video Settings</h2>

        <Border>
          <Collapsible trigger="Video Source">
            <br></br>
            <select
              value={videoSource || "youtube"}
              onChange={(event) => {

                videoSource = event.target.value;

                this.props.onUpdated(videoSource, videoUrl, icon, iconImage, overlay, pubCode);
              }}
            >
              <option value="youtube">YouTube</option>
              <option value="vimeo">Vimeo</option>
              <option value="wistia">Wistia</option>
              <option value="rumble">Rumble</option>
              <option value="jwp">JWP</option>
              <option value="html">HTML5 Source</option>
            </select>
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Video ID/URL">
            <br></br>
            <input
              type="text"
              defaultValue={videoUrl}
              placeholder="jNQXAC9IVRw"
              onChange={(event) => {
                videoUrl = event.target.value;
                this.props.onUpdated(videoSource, videoUrl, icon, iconImage, overlay, pubCode);
              }}
            />
          </Collapsible>
        </Border>

        {videoSource === "rumble" && (
          <Border>
            <Collapsible trigger="Pub Code">
              <br />
              <input
                type="text"
                defaultValue={this.state.pubCode}
                onChange={(event) => {
                  const pubCode = event.target.value;
                  this.setState({ pubCode }, () => {
                    this.props.onUpdated(videoSource, videoUrl, icon, iconImage, overlay, pubCode);
                  });
                }}
              />
            </Collapsible>
          </Border>
        )}

        <Border>
          <Collapsible trigger="Video Size">
            <br></br>

            <select
              value={overlay || "6"}
              onChange={(event) => {
                overlay = event.target.value;
                this.props.onUpdated(videoSource, videoUrl, icon, iconImage, overlay, pubCode);
              }}
            >
              <option value="3">Small</option>
              <option value="6">Medium</option>
              <option value="9">Large</option>
            </select>
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger="Icon">
            <br></br>
            <Toggle
              id="button_icon_toggle"
              checked={icon != null}
              title="Enable Icon"
              onChange={(checked) => {
                if (checked) {
                  iconImage = null;
                  icon=`icon ${this.props.iconSize || "icon--sm"} icon-Add-File`
                } else {
                  icon = null;
                }

                this.props.onUpdated(videoSource, videoUrl, icon, iconImage, overlay, pubCode);
              }}
            />

            {icon &&
              <IconAndSVGPicker
                label="Default / Selected Icon"
                displayIconFontSize={30}
                displayIconClassName="color--dark"
                currentIcon={icon}
                iconPickerColumnWidth={110}
                iconPickerClassName=""
                iconPickerWidth={356}
                iconPickerRowHeight={110}
                onSelected={(actionType, actionValue) => {
                  iconImage = null;
                  if (actionType === "svg") {
                    this.props.onUpdated(videoSource, videoUrl, updateIconValue(actionType, icon, actionValue), iconImage, overlay, pubCode)
                  } else if (actionType === 'type') {
                    this.props.onUpdated(videoSource, videoUrl, updateIconType(icon, actionValue), iconImage, overlay, pubCode)
                  } else {
                    let value = ""
                    if (actionValue.icon.startsWith("fa-")) {
                      value = `${actionValue.icon} icon--lg`
                    } else {
                      value = "icon icon--lg icon-" + actionValue.name
                    }
                    this.props.onUpdated(videoSource, videoUrl, updateIconValue(actionType, icon, value), iconImage, overlay, pubCode)
                    this.setState({ showIconPickerModal: false })
                  }
                }}
              />
            }
          </Collapsible>
        </Border>

        <Border>
          <Collapsible trigger={"Image"}>
            <br />
            <ImageUploader
              title={""}
              type="illustration"
              src={iconImage?.original}
              onUploaded={(image) => {
                icon = null;
                this.props.onUpdated(videoSource, videoUrl, icon, image, overlay, pubCode);
              }}
            />
          </Collapsible>
        </Border>
      </PortalModal>
    );
  }

  _renderEditable(editable, videoUrl) {
    if (!editable) {
      return null;
    }

    return (
      <>
        <a
          href="javascript:void(0)"
          className="edit edit-button edit-button-video min-width-auto"
          onClick={() => this.setState({ showEditModal: true })}
        >
          <i className="icon icon--xs icon-Pencil" />
        </a>
        {this._renderEditModal(videoUrl)}
      </>
    );
  }

  render() {
    let { videoUrl, className, editable, icon, overlay, iconImage } =
      this.state;

    if (!videoUrl && !editable) {
      return null;
    }

    className = "min-width-auto video-play-icon ";

    let playButton = (
      <a
        href="javascript:void(0)"
        onClick={() => this.setState({ showVideoModal: true })}
        className={className}
      ></a>
    );

    return (
      <div className="modal-instance block">
        <div className="video-play relative d-inline-block">
          {!icon && !iconImage && playButton}

          {icon && (
            <>
            {
              getIconType(icon) === 'svg' ?
                <img
                  className="m-0"
                  src={getSVGIcon(icon)}
                  style={{ height: "5.57142857em" }}
                  onClick={() => this.setState({ showVideoModal: true })}
                />
              :
                <a
                  href="javascript:void(0)"
                  onClick={() => this.setState({ showVideoModal: true })}
                  className={getStandardIcon(icon)}
                ></a>
            }
            </>
          )}

          {iconImage && (
            <a
              href="javascript:void(0)"
              onClick={() => this.setState({ showVideoModal: true })}
              className="min-width-auto"
            >
              <img
                src={iconImage?.original}
                alt="Button Image"
                loading="lazy"
                style={{ maxHeight: 200 }}
              />
            </a>
          )}

          {this._renderVideoModal(videoUrl)}
          {this._renderEditable(editable, videoUrl, icon, overlay)}
        </div>
      </div>
    );
  }
}
